export default "/images/bg-crm.svg?9581dee0ea64cd7c1e0b2bef47f233b7";